import fetch from 'isomorphic-fetch';
import Config from '../../config/';
import { detect } from 'detect-browser';
const browser = detect();

const API = {
  data: {
    async getDrivers() {
      let response = await fetch(
        `https://cors-anywhere.herokuapp.com/https://5d4440b0d823c3001477150f.mockapi.io/api/asignador/driver`,
        {
          method: 'GET',
          headers: new Headers({
            Pragma: 'no-cache',
            mode: 'no-cors'
          })
        }
      );

      const status = response.status;
      let data = await response.json();
      return {
        data: data,
        status: status
      };
    },
    async getEquip() {
      let response = await fetch(
        `https://cors-anywhere.herokuapp.com/https://5d4440b0d823c3001477150f.mockapi.io/api/asignador/equip`,
        {
          method: 'GET',
          headers: new Headers({
            Pragma: 'no-cache',
            mode: 'no-cors'
          })
        }
      );

      const status = response.status;
      let data = await response.json();
      return {
        data: data,
        status: status
      };
    },
    async getTest() {
      let response = await fetch(
        `https://cors-anywhere.herokuapp.com/https://5d4440b0d823c3001477150f.mockapi.io/api/asignador/testDrier`,
        {
          method: 'GET',
          headers: new Headers({
            Pragma: 'no-cache',
            mode: 'no-cors'
          })
        }
      );

      const status = response.status;
      let data = await response.json();
      return {
        data: data,
        status: status
      };
    }
  }
};
export default API;



// WEBPACK FOOTER //
// ./source/client/actions/allocator/api/index.js